import {EventBus} from "../../events/EventBus";
import {GoogleOneTapFirstSignInEvent, WhitelabelEvent} from "../../events/Events";

export class WelcomeEmailSender {
    private eventBus: EventBus;

    constructor() {
        this.eventBus = EventBus.getInstance();
        this.initializeEvents();
    }

    initializeEvents() {
        this.eventBus.subscribeWithId(
            GoogleOneTapFirstSignInEvent.TYPE,
            {
                id: `${GoogleOneTapFirstSignInEvent.TYPE}-handler`,
                callback: this.makeActionOnFirstGoogleOneTapSignIn
            }
        );
    }

    makeActionOnFirstGoogleOneTapSignIn(event: WhitelabelEvent) {
        const {brand, userName, userEmail, searchUrl} = (event as GoogleOneTapFirstSignInEvent).payload;
        const searchUrlParam: string = !searchUrl ? '' : `&search-url=${encodeURIComponent(searchUrl)}`;
        fetch(`/api/${brand.toLowerCase()}/googleOneTapActions?userName=${userName}&userEmail=${userEmail}${searchUrlParam}`);
    }
}
